.continue-btn {
  margin-left: auto;
}
